import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/home.vue'
import Task from '../views/task.vue'
import Auxiliary from '../views/auxiliary.vue'
import Target from '../views/target.vue'
import Environment from '../views/environment.vue'
import subMap from '../components/subMap.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		meta: {
			// requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
		},
		component: Home
	},{
		path: '/Home',
		name: 'Home',
		meta: {
			// requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
		},
		component: Home
	},{
		path: '/Task',
		name: 'Task',
		meta: {
			// requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
		},
		component: Task
	},{
		path: '/Auxiliary',
		name: 'Auxiliary',
		meta: {
			// requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
		},
		component: Auxiliary
	},{
		path: '/Target',
		name: 'Target',
		meta: {
			// requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
		},
		component: Target
	},{
		path: '/Environment',
		name: 'Environment',
		meta: {
			// requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
		},
		component: Environment
	},{
		path: '/subMap',
		name: 'subMap',
		meta: {
			// requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
		},
		component: subMap
	},

]

const router = new VueRouter({
  routes
})

export default router
